import { api } from 'utility';
import { getAllBusinessInfoUrl } from 'URLs';
export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}

export default { getBusinessList };
